export const WEBSITE_MAX_WIDTH = '1920px'
